"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.estimateGasLimit = exports.inferEthereumGasLimitRequest = exports.buildEthereumTx = exports.inferTokenAccount = exports.toTransactionRaw = exports.fromTransactionRaw = exports.getGasLimit = exports.formatTransaction = exports.validateRecipient = exports.getRecipientWarning = exports.isRecipientValid = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var logs_1 = require("@ledgerhq/logs");
var common_1 = __importDefault(require("@ethereumjs/common"));
var tx_1 = require("@ethereumjs/tx");
var eip55_1 = __importDefault(require("eip55"));
var errors_1 = require("@ledgerhq/errors");
var common_2 = require("../../transaction/common");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var Ethereum_1 = require("../../api/Ethereum");
var cache_1 = require("../../cache");
var env_1 = require("../../env");
var modules_1 = require("./modules");
var range_1 = require("../../range");
function isRecipientValid(_currency, recipient) {
    if (!recipient.match(/^0x[0-9a-fA-F]{40}$/))
        return false;
    // To handle non-eip55 addresses we stop validation here if we detect
    // address is either full upper or full lower.
    // see https://github.com/LedgerHQ/ledger-live-desktop/issues/1397
    var slice = recipient.substr(2);
    var isFullUpper = slice === slice.toUpperCase();
    var isFullLower = slice === slice.toLowerCase();
    if (isFullUpper || isFullLower)
        return true;
    try {
        return eip55_1["default"].verify(recipient);
    }
    catch (error) {
        return false;
    }
}
exports.isRecipientValid = isRecipientValid;
// Returns a warning if we detect a non-eip address
function getRecipientWarning(currency, recipient) {
    if (!recipient.match(/^0x[0-9a-fA-F]{40}$/))
        return null;
    var slice = recipient.substr(2);
    var isFullUpper = slice === slice.toUpperCase();
    var isFullLower = slice === slice.toLowerCase();
    if (isFullUpper || isFullLower) {
        return new errors_1.ETHAddressNonEIP();
    }
    return null;
}
exports.getRecipientWarning = getRecipientWarning;
function validateRecipient(currency, recipient, _a) {
    var errors = _a.errors, warnings = _a.warnings;
    var recipientWarning = getRecipientWarning(currency, recipient);
    if (recipientWarning) {
        warnings.recipient = recipientWarning;
    }
    if (!recipient) {
        errors.recipient = new errors_1.RecipientRequired("");
    }
    else if (!isRecipientValid(currency, recipient)) {
        errors.recipient = new errors_1.InvalidAddress("", {
            currencyName: currency.name
        });
    }
}
exports.validateRecipient = validateRecipient;
var formatTransaction = function (t, mainAccount) {
    var gasLimit = (0, exports.getGasLimit)(t);
    var account = (t.subAccountId &&
        (mainAccount.subAccounts || []).find(function (a) { return a.id === t.subAccountId; })) ||
        mainAccount;
    var header = (function () {
        var _a, _b;
        switch (t.mode) {
            case "erc721.transfer":
                return "".concat(t.mode.toUpperCase(), " Collection: ").concat(t.collection, " (").concat(t.collectionName || "", ") TokenId: ").concat((_a = t.tokenIds) === null || _a === void 0 ? void 0 : _a[0]);
            case "erc1155.transfer":
                return ("".concat(t.mode.toUpperCase(), " Collection: ").concat(t.collection, " (").concat(t.collectionName || "", ")") +
                    ((_b = t.tokenIds) === null || _b === void 0 ? void 0 : _b.map(function (tokenId, index) {
                        var _a, _b, _c;
                        return "\n  - TokenId: ".concat(tokenId, " Quantity: ").concat((_c = (_b = (_a = t.quantities) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.toFixed()) !== null && _c !== void 0 ? _c : 0);
                    }).join(",")));
            default:
                return "".concat(t.mode.toUpperCase(), " ").concat(t.useAllAmount
                    ? "MAX"
                    : (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), t.amount, {
                        showCode: true,
                        disableRounding: true
                    }));
        }
    })();
    return "\n".concat(header, "\nTO ").concat(t.recipient, "\nwith gasPrice=").concat((0, currencies_1.formatCurrencyUnit)(mainAccount.currency.units[1] || mainAccount.currency.units[0], t.gasPrice || new bignumber_js_1.BigNumber(0)), "\nwith gasLimit=").concat(gasLimit.toString());
};
exports.formatTransaction = formatTransaction;
var defaultGasLimit = new bignumber_js_1.BigNumber(0x5208);
var getGasLimit = function (t) {
    return t.userGasLimit || t.estimatedGasLimit || defaultGasLimit;
};
exports.getGasLimit = getGasLimit;
var fromTransactionRaw = function (tr) {
    var _a;
    var common = (0, common_2.fromTransactionCommonRaw)(tr);
    var networkInfo = tr.networkInfo;
    return __assign(__assign({}, common), { mode: tr.mode, nonce: tr.nonce, data: tr.data ? Buffer.from(tr.data, "hex") : undefined, family: tr.family, gasPrice: tr.gasPrice ? new bignumber_js_1.BigNumber(tr.gasPrice) : null, userGasLimit: tr.userGasLimit ? new bignumber_js_1.BigNumber(tr.userGasLimit) : null, estimatedGasLimit: tr.estimatedGasLimit
            ? new bignumber_js_1.BigNumber(tr.estimatedGasLimit)
            : null, feeCustomUnit: tr.feeCustomUnit, 
        // FIXME this is not good.. we're dereferencing here. we should instead store an index (to lookup in currency.units on UI)
        networkInfo: networkInfo && {
            family: networkInfo.family,
            gasPrice: (0, range_1.fromRangeRaw)(networkInfo.gasPrice)
        }, allowZeroAmount: tr.allowZeroAmount, feesStrategy: tr.feesStrategy, tokenIds: tr.tokenIds, collection: tr.collection, collectionName: tr.collectionName, quantities: (_a = tr.quantities) === null || _a === void 0 ? void 0 : _a.map(function (q) { return new bignumber_js_1.BigNumber(q); }) });
};
exports.fromTransactionRaw = fromTransactionRaw;
var toTransactionRaw = function (t) {
    var _a;
    var common = (0, common_2.toTransactionCommonRaw)(t);
    var networkInfo = t.networkInfo;
    return __assign(__assign({}, common), { mode: t.mode, nonce: t.nonce, family: t.family, data: t.data ? t.data.toString("hex") : undefined, gasPrice: t.gasPrice ? t.gasPrice.toString() : null, userGasLimit: t.userGasLimit ? t.userGasLimit.toString() : null, estimatedGasLimit: t.estimatedGasLimit
            ? t.estimatedGasLimit.toString()
            : null, feeCustomUnit: t.feeCustomUnit, 
        // FIXME drop?
        networkInfo: networkInfo && {
            family: networkInfo.family,
            gasPrice: (0, range_1.toRangeRaw)(networkInfo.gasPrice)
        }, allowZeroAmount: t.allowZeroAmount, feesStrategy: t.feesStrategy, tokenIds: t.tokenIds, collection: t.collection, collectionName: t.collectionName, quantities: (_a = t.quantities) === null || _a === void 0 ? void 0 : _a.map(function (q) { return q.toString(); }) });
};
exports.toTransactionRaw = toTransactionRaw;
// see https://github.com/ethereum/EIPs/blob/master/EIPS/eip-155.md
function getEthereumjsTxCommon(currency) {
    var ethereumLikeInfo = currency.ethereumLikeInfo;
    (0, invariant_1["default"])(ethereumLikeInfo, "currency ".concat(currency.id, " did not set ethereumLikeInfo"));
    if (ethereumLikeInfo.chainId === 1) {
        return new common_1["default"]({
            chain: ethereumLikeInfo.baseChain || "mainnet",
            hardfork: ethereumLikeInfo.hardfork || "petersburg"
        });
    }
    return common_1["default"].forCustomChain(ethereumLikeInfo.baseChain || "mainnet", {
        name: currency.ticker,
        chainId: ethereumLikeInfo.chainId,
        networkId: ethereumLikeInfo.networkId || ethereumLikeInfo.chainId
    }, ethereumLikeInfo.hardfork || "petersburg");
}
function inferTokenAccount(a, t) {
    var tokenAccount = !t.subAccountId
        ? null
        : a.subAccounts && a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; });
    if (tokenAccount && tokenAccount.type === "TokenAccount") {
        return tokenAccount;
    }
}
exports.inferTokenAccount = inferTokenAccount;
function buildEthereumTx(account, transaction, nonce) {
    var currency = account.currency;
    var gasPrice = transaction.gasPrice;
    var subAccount = inferTokenAccount(account, transaction);
    (0, invariant_1["default"])(!subAccount || subAccount.type === "TokenAccount", "only token accounts expected");
    var common = getEthereumjsTxCommon(currency);
    if (!common) {
        throw new Error("common not found for currency ".concat(currency.name));
    }
    var gasLimit = (0, exports.getGasLimit)(transaction);
    var ethTxObject = {
        nonce: nonce,
        gasPrice: "0x".concat(new bignumber_js_1.BigNumber(gasPrice || 0).toString(16)),
        gasLimit: "0x".concat(new bignumber_js_1.BigNumber(gasLimit).toString(16))
    };
    var m = modules_1.modes[transaction.mode];
    (0, invariant_1["default"])(m, "missing module for mode=" + transaction.mode);
    var fillTransactionDataResult = m.fillTransactionData(account, transaction, ethTxObject);
    (0, logs_1.log)("ethereum", "buildEthereumTx", ethTxObject);
    var tx = new tx_1.Transaction(ethTxObject, { common: common });
    return {
        tx: tx,
        common: common,
        ethTxObject: ethTxObject,
        fillTransactionDataResult: fillTransactionDataResult
    };
}
exports.buildEthereumTx = buildEthereumTx;
function inferEthereumGasLimitRequest(account, transaction) {
    var r = {
        from: account.freshAddress,
        amplifier: "1"
    };
    if (transaction.gasPrice) {
        r.gasPrice = "0x" + transaction.gasPrice.toString();
    }
    try {
        var _a = buildEthereumTx(account, transaction, 1).tx, data = _a.data, to = _a.to, value = _a.value;
        if (value) {
            r.value = "0x" + (value.toString("hex") || "0");
        }
        if (to) {
            r.to = to.toString();
        }
        if (data) {
            r.data = "0x" + data.toString("hex");
        }
    }
    catch (e) {
        (0, logs_1.log)("warn", "couldn't serializeTransactionData: " + e);
    }
    return r;
}
exports.inferEthereumGasLimitRequest = inferEthereumGasLimitRequest;
exports.estimateGasLimit = (0, cache_1.makeLRUCache)(function (account, addr, request) {
    var api = (0, Ethereum_1.apiForCurrency)(account.currency);
    return api
        .getDryRunGasLimit(addr, request)
        .then(function (value) {
        return value.eq(21000) // regular ETH send should not be amplified
            ? value
            : value.times((0, env_1.getEnv)("ETHEREUM_GAS_LIMIT_AMPLIFIER")).integerValue();
    })["catch"](function () { return api.roughlyEstimateGasLimit(addr); });
}, function (a, addr, r) {
    return a.id +
        "|" +
        addr +
        "|" +
        String(r.from) +
        "+" +
        String(r.to) +
        "+" +
        String(r.value) +
        "+" +
        String(r.data) +
        "+" +
        String(r.gasPrice) +
        "+" +
        String(r.amplifier);
});
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: exports.fromTransactionRaw,
    toTransactionRaw: exports.toTransactionRaw
};
//# sourceMappingURL=transaction.js.map